export const expData = {
  1: 15,
  2: 34,
  3: 57,
  4: 92,
  5: 135,
  6: 372,
  7: 560,
  8: 840,
  9: 1242,
  10: 1242,
  11: 1242,
  12: 1242,
  13: 1242,
  14: 1242,
  15: 1490,
  16: 1788,
  17: 2145,
  18: 2574,
  19: 3088,
  20: 3705,
  21: 4446,
  22: 5335,
  23: 6402,
  24: 7682,
  25: 9218,
  26: 11061,
  27: 13273,
  28: 15927,
  29: 19112,
  30: 19112,
  31: 19112,
  32: 19112,
  33: 19112,
  34: 19112,
  35: 22934,
  36: 27520,
  37: 33024,
  38: 39628,
  39: 47553,
  40: 51357,
  41: 55465,
  42: 59902,
  43: 64694,
  44: 69869,
  45: 75458,
  46: 81494,
  47: 88013,
  48: 95054,
  49: 102658,
  50: 110870,
  51: 119739,
  52: 129318,
  53: 139663,
  54: 150836,
  55: 162902,
  56: 175934,
  57: 190008,
  58: 205208,
  59: 221624,
  60: 221624,
  61: 221624,
  62: 221624,
  63: 221624,
  64: 221624,
  65: 238245,
  66: 256113,
  67: 275321,
  68: 295970,
  69: 318167,
  70: 342029,
  71: 367681,
  72: 395257,
  73: 424901,
  74: 456768,
  75: 488741,
  76: 522952,
  77: 559558,
  78: 598727,
  79: 640637,
  80: 685481,
  81: 733464,
  82: 784806,
  83: 839742,
  84: 898523,
  85: 961419,
  86: 1028718,
  87: 1100728,
  88: 1177778,
  89: 1260222,
  90: 1342136,
  91: 1429374,
  92: 1522283,
  93: 1621231,
  94: 1726611,
  95: 1838840,
  96: 1958364,
  97: 2085657,
  98: 2221224,
  99: 2365603,
  100: 2365603,
  101: 2365603,
  102: 2365603,
  103: 2365603,
  104: 2365603,
  105: 2519367,
  106: 2683125,
  107: 2857528,
  108: 3043267,
  109: 3241079,
  110: 3451749,
  111: 3676112,
  112: 3915059,
  113: 4169537,
  114: 4440556,
  115: 4729192,
  116: 5036589,
  117: 5363967,
  118: 5712624,
  119: 6083944,
  120: 6479400,
  121: 6900561,
  122: 7349097,
  123: 7826788,
  124: 8335529,
  125: 8877338,
  126: 9454364,
  127: 10068897,
  128: 10723375,
  129: 11420394,
  130: 12162719,
  131: 12953295,
  132: 13795259,
  133: 14691950,
  134: 15646926,
  135: 16663976,
  136: 17747134,
  137: 18900697,
  138: 20129242,
  139: 21437642,
  140: 22777494,
  141: 24201087,
  142: 25713654,
  143: 27320757,
  144: 29028304,
  145: 30842573,
  146: 32770233,
  147: 34818372,
  148: 36994520,
  149: 39306677,
  150: 41763344,
  151: 44373553,
  152: 47146900,
  153: 50093581,
  154: 53224429,
  155: 56550955,
  156: 60085389,
  157: 63840725,
  158: 67830770,
  159: 72070193,
  160: 76574580,
  161: 81360491,
  162: 86445521,
  163: 91848366,
  164: 97588888,
  165: 103688193,
  166: 110168705,
  167: 117054249,
  168: 124370139,
  169: 132143272,
  170: 138750435,
  171: 145687956,
  172: 152972353,
  173: 160620970,
  174: 168652018,
  175: 177084618,
  176: 185938848,
  177: 195235790,
  178: 204997579,
  179: 215247457,
  180: 226009829,
  181: 237310320,
  182: 249175836,
  183: 261634627,
  184: 274716358,
  185: 288452175,
  186: 302874783,
  187: 318018522,
  188: 333919448,
  189: 350615420,
  190: 368146191,
  191: 386553500,
  192: 405881175,
  193: 426175233,
  194: 447483994,
  195: 469858193,
  196: 493351102,
  197: 518018657,
  198: 543919589,
  199: 571115568,
  200: 2207026470,
  201: 2471869646,
  202: 2768494003,
  203: 3100713283,
  204: 3472798876,
  205: 3889534741,
  206: 4356278909,
  207: 4879032378,
  208: 5464516263,
  209: 6120258214,
  210: 7344309856,
  211: 8152183940,
  212: 9048924173,
  213: 10044305832,
  214: 11149179473,
  215: 13379015367,
  216: 14583126750,
  217: 15895608157,
  218: 17326212891,
  219: 18885572051,
  220: 22662686461,
  221: 24249074513,
  222: 25946509728,
  223: 27762765408,
  224: 29706158986,
  225: 35647390783,
  226: 38142708137,
  227: 40812697706,
  228: 43669586545,
  229: 46726457603,
  230: 56071749123,
  231: 57753901596,
  232: 59486518643,
  233: 61271114202,
  234: 63109247628,
  235: 75731097153,
  236: 78003030067,
  237: 80343120969,
  238: 82753414598,
  239: 85236017035,
  240: 102283220442,
  241: 105351717055,
  242: 108512268566,
  243: 111767636622,
  244: 115120665720,
  245: 138144798864,
  246: 142289142829,
  247: 146557817113,
  248: 150954551626,
  249: 155483188174,
  250: 186579825808,
  251: 192177220582,
  252: 197942537199,
  253: 203880813314,
  254: 209997237713,
  255: 216297154844,
  256: 222786069489,
  257: 229469651573,
  258: 236353741120,
  259: 243444353353,
  260: 1731919984062,
  261: 1749239183902,
  262: 1766731575741,
  263: 1784398891498,
  264: 1802242880412,
  265: 2342915744535,
  266: 2366344901980,
  267: 2390008350999,
  268: 2413908434508,
  269: 2438047518853,
  270: 5412465491853,
  271: 5466590146771,
  272: 5521256048238,
  273: 5576468608720,
  274: 5632233294807,
  275: 11377111255510,
  276: 12514822381061,
  277: 13766304619167,
  278: 15142935081083,
  279: 16657228589191,
  280: 33647601750165,
  281: 37012361925181,
  282: 40713598117699,
  283: 44784957929468,
  284: 49263453722414,
  285: 99512176519276,
  286: 109463394171203,
  287: 120409733588323,
  288: 132450706947155,
  289: 145695777641870,
  290: 294305470836577,
  291: 323736017920234,
  292: 356109619712257,
  293: 391720581683482,
  294: 430892639851830,
  295: 870403132500696,
  296: 957443445750765,
  297: 1053187790325840,
  298: 1158506569358420,
  299: 1737759854037630,
  300: Infinity
}

export const potions = [
  { name: '終極成長秘藥', count: 0, maxLevel: 199 },
  { name: '究極聯盟成長秘藥', count: 0, maxLevel: 200, expSum: 11462335230 },
  { name: '成長秘藥(Lv200~209)', count: 0, maxLevel: 209 },
  { name: '成長秘藥(Lv200~219)', count: 0, maxLevel: 219 },
  { name: '成長秘藥(Lv200~229)', count: 0, maxLevel: 229 },
  { name: '颱風成長秘藥(Lv200~239)', count: 0, maxLevel: 239 },
  { name: '極限成長秘藥(Lv200~249)', count: 0, maxLevel: 249 },
  { name: '跳躍成長秘藥(Lv200~259)', count: 0, maxLevel: 259 },
  { name: '超越成長秘藥(Lv200~269)', count: 0, maxLevel: 269 },
  { name: '咖凌的特製秘藥(Lv200~274)', count: 0, maxLevel: 274 },
  { name: '傳說成長秘藥(Lv200~279)', count: 0, maxLevel: 279 }
]

export const calculateResult = (currentLevel, currentExpValue, potions) => {
  if (!currentLevel || !currentExpValue) return null

  let totalExp = parseInt(currentExpValue.replace(/,/g, ''))
  let level = currentLevel

  // 計算每種秘藥提供的經驗值
  potions.forEach(potion => {
    if (potion.count > 0) {
      const maxLevel = potion.maxLevel
      for (let i = 0; i < potion.count; i++) {
        if (level <= maxLevel) {
          totalExp += expData[level]
          if (totalExp >= expData[level]) {
            totalExp -= expData[level]
            level++
          }
        } else {
          totalExp += expData[maxLevel]
        }
      }
    }
  })

  return {
    level: level,
    exp: totalExp,
    levelExp: expData[level],
    percentage: (totalExp / expData[level]) * 100
  }
}

export const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
} 